// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"5ceeb60b514215d6","931":"84c6788bc6257568"}[chunkId] + ".css";
};